var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelMailSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 11,
  viewBox: "0 0 14 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 .996A1 1 0 0 1 1.007 0h11.986A1 1 0 0 1 14 .996v1.111l-6.682 4.52c-.277.191-.277.191-.555 0L0 2.053zm0 2.087v5.849l4.267-2.949zm0 6.948c.015.537.459.969 1.007.969h11.986A1 1 0 0 0 14 10.004v-.027c-1.319-.898-3.564-2.428-5.018-3.427l-1.11.842c-.277.192-1.386.192-1.663 0l-1.123-.844zm14-1.112V3.095L9.793 5.983z"
})));
export default SvgChannelMailSm;